import { lazy } from 'react';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

//Screens
const NotFound = Loadable(lazy(() => import('views/pages/not-found')));
const SettingsScreen = Loadable(lazy(() => import('views/pages/settings')));
const ReadsScreen = Loadable(lazy(() => import('views/pages/reads')));
const SensorsScreen = Loadable(lazy(() => import('views/pages/admin/sensors')));
const InventoryScreen = Loadable(lazy(() => import('views/pages/inventory')));
const AdminChartsScreen = Loadable(lazy(() => import('views/pages/admin/charts/charts')));
const ExpeditionsScreen = Loadable(lazy(() => import('views/pages/expeditions')));
const CreateExpeditionScreen = Loadable(lazy(() => import('views/pages/expeditions/create-expedition')));
const UserManagementScreen = Loadable(lazy(() => import('views/pages/admin/user-management')));
const IncidencesScreen = Loadable(lazy(() => import('views/pages/incidences')));
const DeviceConfigScreen = Loadable(lazy(() => import('views/pages/device-config')));


// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {

        path: '/',
        element: <MainLayout/>,
        children: [
            {
                path: '*',
                element: <NotFound/>
            },
            {
                path: '/',
                element: <ReadsScreen/>
            },
            {
                path: 'dashboard',
                children: [
                    {
                        path: 'lecturas',
                        element: <ReadsScreen/>
                    },
                    {
                        path: 'inventario',
                        element: <InventoryScreen/>
                    },
                    {
                        path: 'expediciones',
                        element: <ExpeditionsScreen/>
                    },
                    {
                        path: 'incidencias',
                        element: <IncidencesScreen/>
                    },
                ]
            },
            {
                path: 'admin',
                children: [
                    {
                        path: 'configurar-id-dispositivo',
                        element: <DeviceConfigScreen text={'Selecciona cual de los dispositivos disponibles es el actual'} mandatory={false} />
                    },
                    // {
                    //     path: 'stats',
                    //     element: <AdminChartsScreen/>
                    // },
                    {
                        path: 'sensores',
                        element: <SensorsScreen/>
                    },
                    {
                        path: 'usuarios',
                        element: <UserManagementScreen/>
                    },
                ]
            },
        ]
};

export default MainRoutes;
